// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 21/08/2025

/* eslint-disable import/no-anonymous-default-export */
import EndOfDayActionTypes from './end-of-day.types';
import { docodeHexResponse } from '../../_common/common.utils';
const INITIAL_STATE = {
	// Get All Collection Details
	getAllCollectionDetailsResponse: null,
	getAllCollectionDetailsArr: [],
	// Get Branch EOD Wallet Details
	getBranchEODWalletDetailsResponse: null,
	getBranchEODWalletDetailsArr: [],
	// Get Demand Collection Total Details
	getDemandCollectionTotalDetailsResponse: null,
	getDemandCollectionTotalDetailsArr: [],
	// Get Advance Collection Total Details
	getAdvanceCollectionTotalDetailsResponse: null,
	getAdvanceCollectionTotalDetailsArr: [],
	// Get Arrear Collection Total Details
	getArrearCollectionTotalDetailsResponse: null,
	getArrearCollectionTotalDetailsArr: [],
	// Get Wallet Collection Total Details
	getWalletCollectionTotalDetailsResponse: null,
	getWalletCollectionTotalDetailsArr: [],
	// Get Preclose Collection Total Details
	getPrecloseCollectionTotalDetailsResponse: null,
	getPrecloseCollectionTotalDetailsArr: [],
	// GET BRANCH EOD YET TO COLLECTION ARREAR
	getBranchEODYetToCollectArrearDetailsResponse: null,
	getBranchEODYetToCollectArrearDetailsArr: [],
	// Get Loan Advance Used Total Details
	getLoanAdvanceUsedTotalDetailsResponse: null,
	getLoanAdvanceUsedTotalDetailsArr: [],
	// Get Close Loan List Details
	getCloseLoanListDetailsResponse: null,
	getCloseLoanListDetailsArr: [],
	getCloseLoanListDetailsStatus: null,
	// Get Preclose Collection Details
	getPrecloseCollectionDetailsResponse: null,
	getPrecloseCollectionDetailsArr: [],
	// Get Advance Collection Details
	getAdvanceCollectionDetailsResponse: null,
	getAdvanceCollectionDetailsArr: [],
	// Get Arrear Collection Details
	getArrearCollectionDetailsResponse: null,
	getArrearCollectionDetailsArr: [],
	// Get Voucher Approved Details
	getVoucherApprovedDetailsResponse: null,
	getVoucherApprovedDetailsArr: [],
	// Get Submit EOD Details
	getSubmitEODDetailsResponse: null,
	getSubmitEODDetailsArr: [],
	// Get Revert EOD Details
	getRevertEODDetailsResponse: null,
	getRevertEODDetailsArr: [],
	// Get Account Day Book Report
	getAccountDayBookReportResponse: null,
	getAccountDayBookReportData: null,
	getAccountDayBookReportArr: [],
	// Get Previous Day Bank Account Day Book Report
	getPreviousDayBankAccountDayBookReportResponse: null,
	getPreviousDayBankAccountDayBookReportArr: [],
	// Get Bank Account Day Book Report
	getBankAccountDayBookReportResponse: null,
	getBankAccountDayBookReportArr: [],
	// Get Previous Day Cash Account Day Book Report
	getPreviousDayCashAccountDayBookReportResponse: null,
	getPreviousDayCashAccountDayBookReportArr: [],
	// Get Cash Account Day Book Report
	getCashAccountDayBookReportResponse: null,
	getCashAccountDayBookReportArr: [],
	// Get Branch EOD Thrift Details
	getBranchEODThriftDetailsResponse: null,
	getBranchEODThriftDetailsArr: [],
	// Get Branch EOD Savings Details
	getBranchEODSavingsDetailsResponse: null,
	getBranchEODSavingsDetailsArr: [],
	// Get Branch EOD Fixed Deposit Details
	getBranchEODFixedDepositDetailsResponse: null,
	getBranchEODFixedDepositDetailsArr: [],
	// Get Branch EOD Details
	getBranchEODDetailsResponse: null,
	getBranchEODDetailsArr: [],
	// Get EOD Savings Collection Details
	getEODSavingsCollectionDetailsResponse: null,
	getEODSavingsCollectionDetailsArr: [],

	// Get EOD Staff Travel Details
	getEODStaffTravelDetailsResponse: null,
	getEODStaffTravelDetailsArr: [],

	// Submit Staff Travel EOD Details
	submitEODStaffTravelDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START GET ALL COLLECTION DETAILS  ******************** */
		case EndOfDayActionTypes.GET_ALL_COLLECTION_DETAILS_SUCCESS:
			return {
				...state,
				getAllCollectionDetailsResponse: action.payload,
				getAllCollectionDetailsArr: docodeHexResponse(
					action.payload,
					'GetAllCollectionDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_ALL_COLLECTION_DETAILS_FAILURE:
			return {
				...state,
				getAllCollectionDetailsResponse: action.payload,
				getAllCollectionDetailsArr: [],
			};

		case EndOfDayActionTypes.GET_ALL_COLLECTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, getAllCollectionDetailsResponse: null };
		/** *********************  END GET ALL COLLECTION DETAILS  ******************** */

		/** *********************  START GET BRANCH EOD WALLET DETAILS  ******************** */
		case EndOfDayActionTypes.GET_BRANCH_EOD_WALLET_DETAILS_SUCCESS:
			return {
				...state,
				getBranchEODWalletDetailsResponse: action.payload,
				getBranchEODWalletDetailsArr: docodeHexResponse(
					action.payload,
					'GetEODWalletAmountDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_BRANCH_EOD_WALLET_DETAILS_FAILURE:
			return {
				...state,
				getBranchEODWalletDetailsResponse: action.payload,
			};

		case EndOfDayActionTypes.GET_BRANCH_EOD_WALLET_DETAILS_RESPONSE_CHANGED:
			return { ...state, getBranchEODWalletDetailsResponse: null };
		/** *********************  END GET BRANCH EOD WALLET DETAILS  ******************** */

		/** *********************  START GET BRANCH EOD THRIFT DETAILS  ******************** */
		case EndOfDayActionTypes.GET_BRANCH_EOD_THRIFT_DETAILS_SUCCESS:
			return {
				...state,
				getBranchEODThriftDetailsResponse: action.payload,
				getBranchEODThriftDetailsArr: docodeHexResponse(
					action.payload,
					'GetBranchEODThriftDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_BRANCH_EOD_THRIFT_DETAILS_FAILURE:
			return { ...state, getBranchEODThriftDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_BRANCH_EOD_THRIFT_DETAILS_RESPONSE_CHANGED:
			return { ...state, getBranchEODThriftDetailsResponse: null };
		/** *********************  END GET BRANCH EOD THRIFT DETAILS  ******************** */

		/** *********************  START GET BRANCH EOD SAVINGS DETAILS  ******************** */
		case EndOfDayActionTypes.GET_BRANCH_EOD_SAVINGS_DETAILS_SUCCESS:
			return {
				...state,
				getBranchEODSavingsDetailsResponse: action.payload,
				getBranchEODSavingsDetailsArr: docodeHexResponse(
					action.payload,
					'GetBranchEODSavingsDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_BRANCH_EOD_SAVINGS_DETAILS_FAILURE:
			return { ...state, getBranchEODSavingsDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_BRANCH_EOD_SAVINGS_DETAILS_RESPONSE_CHANGED:
			return { ...state, getBranchEODSavingsDetailsResponse: null };
		/** *********************  END GET BRANCH EOD SAVINGS DETAILS  ******************** */

		/** *********************  START GET DEMAND COLLECTION TOTAL DETAILS  ******************** */
		case EndOfDayActionTypes.GET_DEMAND_COLLECTION_TOTAL_DETAILS_SUCCESS:
			return {
				...state,
				getDemandCollectionTotalDetailsResponse: action.payload,
				getDemandCollectionTotalDetailsArr: docodeHexResponse(
					action.payload,
					'GetDemandCollectionTotalDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_DEMAND_COLLECTION_TOTAL_DETAILS_FAILURE:
			return { ...state, getDemandCollectionTotalDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_DEMAND_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED:
			return { ...state, getDemandCollectionTotalDetailsResponse: null };
		/** *********************  END GET DEMAND COLLECTION TOTAL DETAILS  ******************** */

		/** *********************  START GET ADVANCE COLLECTION TOTAL DETAILS  ******************** */
		case EndOfDayActionTypes.GET_ADVANCE_COLLECTION_TOTAL_DETAILS_SUCCESS:
			return {
				...state,
				getAdvanceCollectionTotalDetailsResponse: action.payload,
				getAdvanceCollectionTotalDetailsArr: docodeHexResponse(
					action.payload,
					'GetAdvanceCollectionTotalDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_ADVANCE_COLLECTION_TOTAL_DETAILS_FAILURE:
			return { ...state, getAdvanceCollectionTotalDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_ADVANCE_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED:
			return { ...state, getAdvanceCollectionTotalDetailsResponse: null };

		/** *********************  END GET ADVANCE COLLECTION TOTAL DETAILS  ******************** */

		/** *********************  START GET ARREAR COLLECTION TOTAL DETAILS  ******************** */
		case EndOfDayActionTypes.GET_ARREAR_COLLECTION_TOTAL_DETAILS_SUCCESS:
			return {
				...state,
				getArrearCollectionTotalDetailsResponse: action.payload,
				getArrearCollectionTotalDetailsArr: docodeHexResponse(
					action.payload,
					'GetArrearCollectionTotalDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_ARREAR_COLLECTION_TOTAL_DETAILS_FAILURE:
			return { ...state, getArrearCollectionTotalDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_ARREAR_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED:
			return { ...state, getArrearCollectionTotalDetailsResponse: null };
		/** *********************  END GET ARREAR COLLECTION TOTAL DETAILS  ******************** */

		/** *********************  START GET WALLET COLLECTION TOTAL DETAILS  ******************** */
		case EndOfDayActionTypes.GET_WALLET_COLLECTION_TOTAL_DETAILS_SUCCESS:
			return {
				...state,
				getWalletCollectionTotalDetailsResponse: action.payload,
				getWalletCollectionTotalDetailsArr: docodeHexResponse(
					action.payload,
					'GetWalletCollectionTotalDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_WALLET_COLLECTION_TOTAL_DETAILS_FAILURE:
			return { ...state, getWalletCollectionTotalDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_WALLET_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED:
			return { ...state, getWalletCollectionTotalDetailsResponse: null };
		/** *********************  END GET WALLET COLLECTION TOTAL DETAILS  ******************** */

		/** *********************  START GET PRECLOSE COLLECTION TOTAL DETAILS  ******************** */
		case EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_SUCCESS:
			return {
				...state,
				getPrecloseCollectionTotalDetailsResponse: action.payload,
				getPrecloseCollectionTotalDetailsArr: docodeHexResponse(
					action.payload,
					'GetPrecloseCollectionTotalDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_FAILURE:
			return { ...state, getPrecloseCollectionTotalDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_RESPONSE_CHANGED:
			return { ...state, getPrecloseCollectionTotalDetailsResponse: null };
		/** *********************  END GET PRECLOSE COLLECTION TOTAL DETAILS  ******************** */

		/** *********************  START GET LOAN ADVANCE USED TOTAL DETAILS  ******************** */
		case EndOfDayActionTypes.GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_SUCCESS:
			return {
				...state,
				getLoanAdvanceUsedTotalDetailsResponse: action.payload,
				getLoanAdvanceUsedTotalDetailsArr: docodeHexResponse(
					action.payload,
					'GetLoanAdvanceUsedTotalDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_FAILURE:
			return { ...state, getLoanAdvanceUsedTotalDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_RESPONSE_CHANGED:
			return { ...state, getLoanAdvanceUsedTotalDetailsResponse: null };
		/** *********************  END GET LOAN ADVANCE USED TOTAL DETAILS  ******************** */

		/** *********************  START GET CLOSE LOAN LIST DETAILS  ******************** */
		case EndOfDayActionTypes.GET_CLOSE_LOAN_LIST_DETAILS_SUCCESS:
			return {
				...state,
				getCloseLoanListDetailsResponse: action.payload,
				getCloseLoanListDetailsArr: docodeHexResponse(
					action.payload,
					'CloseLoanListFetchKey',
				),
			};

		case EndOfDayActionTypes.GET_CLOSE_LOAN_LIST_DETAILS_FAILURE:
			return { ...state, getCloseLoanListDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_CLOSE_LOAN_LIST_DETAILS_RESPONSE_CHANGED:
			return { ...state, getCloseLoanListDetailsResponse: null };
		/** *********************  END GET CLOSE LOAN LIST DETAILS  ******************** */

		/** *********************  START GET BRANCH EOD DETAILS  ******************** */
		case EndOfDayActionTypes.GET_BRANCH_EOD_DETAILS_SUCCESS:
			return {
				...state,
				getBranchEODDetailsResponse: action.payload,
				getBranchEODDetailsArr: docodeHexResponse(action.payload, 'GetBranchEODDetailsKey'),
			};

		case EndOfDayActionTypes.GET_BRANCH_EOD_DETAILS_FAILURE:
			return { ...state, getBranchEODDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_BRANCH_EOD_DETAILS_RESPONSE_CHANGED:
			return { ...state, getBranchEODDetailsResponse: null };
		/** *********************  END GET BRANCH EOD DETAILS  ******************** */

		/** *********************  START GET PREVIOUS DAY BANK ACCOUNT DAY BOOK REPORT  ******************** */
		case EndOfDayActionTypes.GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_SUCCESS:
			return {
				...state,
				getPreviousDayBankAccountDayBookReportResponse: action.payload,
				getPreviousDayBankAccountDayBookReportArr: docodeHexResponse(
					action.payload,
					'FetchBranchAccountDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_FAILURE:
			return {
				...state,
				getPreviousDayBankAccountDayBookReportResponse: action.payload,
				getPreviousDayBankAccountDayBookReportArr: [],
			};

		case EndOfDayActionTypes.GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED:
			return { ...state, getPreviousDayBankAccountDayBookReportResponse: null };
		/** *********************  END GET PREVIOUS DAY BANK ACCOUNT DAY BOOK REPORT  ******************** */

		/** *********************  START GET BANK ACCOUNT DAY BOOK REPORT  ******************** */
		case EndOfDayActionTypes.GET_BANK_ACCOUNT_DAY_BOOK_REPORT_SUCCESS:
			return {
				...state,
				getBankAccountDayBookReportResponse: action.payload,
				getBankAccountDayBookReportArr: docodeHexResponse(
					action.payload,
					'FetchBranchAccountDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_BANK_ACCOUNT_DAY_BOOK_REPORT_FAILURE:
			return {
				...state,
				getBankAccountDayBookReportResponse: action.payload,
				getBankAccountDayBookReportArr: [],
			};

		case EndOfDayActionTypes.GET_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED:
			return { ...state, getBankAccountDayBookReportResponse: null };
		/** *********************  END GET BANK ACCOUNT DAY BOOK REPORT  ******************** */

		/** *********************  START GET PREVIOUS DAY CASH ACCOUNT DAY BOOK REPORT  ******************** */
		case EndOfDayActionTypes.GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_SUCCESS:
			return {
				...state,
				getPreviousDayCashAccountDayBookReportResponse: action.payload,
				getPreviousDayCashAccountDayBookReportArr: docodeHexResponse(
					action.payload,
					'FetchBranchAccountDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_FAILURE:
			return {
				...state,
				getPreviousDayCashAccountDayBookReportResponse: action.payload,
				getPreviousDayCashAccountDayBookReportArr: [],
			};

		case EndOfDayActionTypes.GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED:
			return { ...state, getPreviousDayCashAccountDayBookReportResponse: null };
		/** *********************  END GET PREVIOUS DAY CASH ACCOUNT DAY BOOK REPORT  ******************** */

		/** *********************  START GET CASH ACCOUNT DAY BOOK REPORT  ******************** */
		case EndOfDayActionTypes.GET_CASH_ACCOUNT_DAY_BOOK_REPORT_SUCCESS:
			return {
				...state,
				getCashAccountDayBookReportResponse: action.payload,
				getCashAccountDayBookReportArr: docodeHexResponse(
					action.payload,
					'FetchBranchAccountDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_CASH_ACCOUNT_DAY_BOOK_REPORT_FAILURE:
			return {
				...state,
				getCashAccountDayBookReportResponse: action.payload,
				getCashAccountDayBookReportArr: [],
			};

		case EndOfDayActionTypes.GET_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED:
			return { ...state, getCashAccountDayBookReportResponse: null };
		/** *********************  END GET CASH ACCOUNT DAY BOOK REPORT  ******************** */

		/** *********************  START GET BRANCH EOD YETTOCOLLECT ARREAR DETAILS  ******************** */
		case EndOfDayActionTypes.GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_SUCCESS:
			return {
				...state,
				getBranchEODYetToCollectArrearDetailsResponse: action.payload,
				getBranchEODYetToCollectArrearDetailsArr: docodeHexResponse(
					action.payload,
					'GetBranchEODYetToCollectArrearDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_FAILURE:
			return {
				...state,
				getBranchEODYetToCollectArrearDetailsResponse: action.payload,
				getBranchEODYetToCollectArrearDetailsArr: [],
			};

		case EndOfDayActionTypes.GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_RESPONSE_CHANGED:
			return { ...state, getBranchEODYetToCollectArrearDetailsResponse: null };
		/** *********************  END GET BRANCH EOD YETTOCOLLECT ARREAR DETAILS  ******************** */

		/** *********************  START GET ACCOUNT DAY BOOK REPORT  ******************** */
		case EndOfDayActionTypes.GET_ACCOUNT_DAY_BOOK_REPORT_SUCCESS:
			return {
				...state,
				getAccountDayBookReportResponse: action.payload,
				getAccountDayBookReportData: action.payload,
				getAccountDayBookReportArr: docodeHexResponse(
					action.payload,
					'FetchBranchAccountDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_ACCOUNT_DAY_BOOK_REPORT_FAILURE:
			return {
				...state,
				getAccountDayBookReportResponse: action.payload,
				getAccountDayBookReportData: action.payload,
				getAccountDayBookReportArr: [],
			};

		case EndOfDayActionTypes.GET_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_CHANGED:
			return { ...state, getAccountDayBookReportResponse: null };
		/** *********************  END GET ACCOUNT DAY BOOK REPORT  ******************** */

		/** *********************  START GET PRECLOSE COLLECTION DETAILS  ******************** */
		case EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_DETAILS_SUCCESS:
			return {
				...state,
				getPrecloseCollectionDetailsResponse: action.payload,
				getPrecloseCollectionDetailsArr: docodeHexResponse(
					action.payload,
					'GetPrecloseCollectionDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_DETAILS_FAILURE:
			return {
				...state,
				getPrecloseCollectionDetailsResponse: action.payload,
				getPrecloseCollectionDetailsArr: [],
			};

		case EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, getPrecloseCollectionDetailsResponse: null };
		/** *********************  END GET PRECLOSE COLLECTION DETAILS  ******************** */

		/** *********************  START GET ADVANCE COLLECTION DETAILS  ******************** */
		case EndOfDayActionTypes.GET_ADVANCE_COLLECTION_DETAILS_SUCCESS:
			return {
				...state,
				getAdvanceCollectionDetailsResponse: action.payload,
				getAdvanceCollectionDetailsArr: docodeHexResponse(
					action.payload,
					'GetAdvanceCollectionDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_ADVANCE_COLLECTION_DETAILS_FAILURE:
			return {
				...state,
				getAdvanceCollectionDetailsResponse: action.payload,
				getAdvanceCollectionDetailsArr: [],
			};

		case EndOfDayActionTypes.GET_ADVANCE_COLLECTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, getAdvanceCollectionDetailsResponse: null };
		/** *********************  END GET ADVANCE COLLECTION DETAILS  ******************** */

		/** *********************  START GET ARREAR COLLECTION DETAILS  ******************** */
		case EndOfDayActionTypes.GET_ARREAR_COLLECTION_DETAILS_SUCCESS:
			return {
				...state,
				getArrearCollectionDetailsResponse: action.payload,
				getArrearCollectionDetailsArr: docodeHexResponse(
					action.payload,
					'GetArrearCollectionDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_ARREAR_COLLECTION_DETAILS_FAILURE:
			return {
				...state,
				getArrearCollectionDetailsResponse: action.payload,
			};

		case EndOfDayActionTypes.GET_ARREAR_COLLECTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, getArrearCollectionDetailsResponse: null };
		/** *********************  END GET ARREAR COLLECTION DETAILS  ******************** */

		/** *********************  START GET VOUCHER APPROVED DETAILS  ******************** */
		case EndOfDayActionTypes.GET_VOUCHER_APPROVED_DETAILS_SUCCESS:
			return {
				...state,
				getVoucherApprovedDetailsResponse: action.payload,
				getVoucherApprovedDetailsArr: docodeHexResponse(
					action.payload,
					'GetVoucherApprovedDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_VOUCHER_APPROVED_DETAILS_FAILURE:
			return {
				...state,
				getVoucherApprovedDetailsResponse: action.payload,
				getVoucherApprovedDetailsArr: [],
			};

		case EndOfDayActionTypes.GET_VOUCHER_APPROVED_DETAILS_RESPONSE_CHANGED:
			return { ...state, getVoucherApprovedDetailsResponse: null };
		/** *********************  END GET VOUCHER APPROVED DETAILS  ******************** */

		/** *********************  START GET SUBMIT EOD DETAILS  ******************** */
		case EndOfDayActionTypes.GET_SUBMIT_EOD_DETAILS_SUCCESS:
			return {
				...state,
				getSubmitEODDetailsResponse: action.payload,
				getSubmitEODDetailsArr: docodeHexResponse(action.payload, 'GetSubmitEODDetailsKey'),
			};

		case EndOfDayActionTypes.GET_SUBMIT_EOD_DETAILS_FAILURE:
			return {
				...state,
				getSubmitEODDetailsResponse: action.payload,
				getSubmitEODDetailsArr: [],
			};

		case EndOfDayActionTypes.GET_SUBMIT_EOD_DETAILS_RESPONSE_CHANGED:
			return { ...state, getSubmitEODDetailsResponse: null };
		/** *********************  END GET SUBMIT EOD DETAILS  ******************** */

		/** *********************  START GET REVERT EOD DETAILS  ******************** */
		case EndOfDayActionTypes.GET_REVERT_EOD_DETAILS_SUCCESS:
			return {
				...state,
				getRevertEODDetailsResponse: action.payload,
				getRevertEODDetailsArr: docodeHexResponse(action.payload, 'GetRevertEODDetailsKey'),
			};

		case EndOfDayActionTypes.GET_REVERT_EOD_DETAILS_FAILURE:
			return {
				...state,
				getRevertEODDetailsResponse: action.payload,
				getRevertEODDetailsArr: [],
			};

		case EndOfDayActionTypes.GET_REVERT_EOD_DETAILS_RESPONSE_CHANGED:
			return { ...state, getRevertEODDetailsResponse: null };
		/** *********************  END GET REVERT EOD DETAILS  ******************** */

		/** *********************  START GET EOD SAVINGS COLLECTION DETAILS  ******************** */
		case EndOfDayActionTypes.GET_EOD_SAVINGS_COLLECTION_DETAILS_SUCCESS:
			return {
				...state,
				getEODSavingsCollectionDetailsResponse: action.payload,
				getEODSavingsCollectionDetailsArr: docodeHexResponse(
					action.payload,
					'GetParticularDateSavingsDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_EOD_SAVINGS_COLLECTION_DETAILS_FAILURE:
			return { ...state, getEODSavingsCollectionDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_EOD_SAVINGS_COLLECTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, getEODSavingsCollectionDetailsResponse: null };
		/** *********************  END GET EOD SAVINGS COLLECTION DETAILS  ******************** */

		/** *********************  START GET EOD GOLD COLLECTION DETAILS  ******************** */
		case EndOfDayActionTypes.GET_EOD_GOLD_COLLECTION_DETAILS_SUCCESS:
			return {
				...state,
				getEODGoldCollectionDetailsResponse: action.payload,
				getEODGoldCollectionDetailsArr: docodeHexResponse(
					action.payload,
					'GetGoldLoanCollectionEODDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_EOD_GOLD_COLLECTION_DETAILS_FAILURE:
			return { ...state, getEODGoldCollectionDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_EOD_GOLD_COLLECTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, getEODGoldCollectionDetailsResponse: null };
		/** *********************  END GET EOD GOLD COLLECTION DETAILS  ******************** */

		/** *********************  START GET EOD STAFF TRAVEL DETAILS  ******************** */
		case EndOfDayActionTypes.GET_EOD_STAFF_TRAVEL_DETAILS_SUCCESS:
			return {
				...state,
				getEODStaffTravelDetailsResponse: action.payload,
				getEODStaffTravelDetailsArr: docodeHexResponse(
					action.payload,
					'GetStaffTravelEODDetailsKey',
				),
			};

		case EndOfDayActionTypes.GET_EOD_STAFF_TRAVEL_DETAILS_FAILURE:
			return { ...state, getEODStaffTravelDetailsResponse: action.payload };

		case EndOfDayActionTypes.GET_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_CHANGED:
			return { ...state, getEODStaffTravelDetailsResponse: null };
		/** *********************  END GET EOD STAFF TRAVEL DETAILS  ******************** */

		/** *********************  START SUBMIT EOD STAFF TRAVEL DETAILS  ******************** */
		case EndOfDayActionTypes.SUBMIT_EOD_STAFF_TRAVEL_DETAILS_SUCCESS:
			return {
				...state,
				submitEODStaffTravelDetailsResponse: action.payload,
			};

		case EndOfDayActionTypes.SUBMIT_EOD_STAFF_TRAVEL_DETAILS_FAILURE:
			return {
				...state,
				submitEODStaffTravelDetailsResponse: action.payload,
			};

		case EndOfDayActionTypes.SUBMIT_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_CHANGED:
			return { ...state, submitEODStaffTravelDetailsResponse: null };
		/** *********************  END SUBMIT EOD STAFF TRAVEL DETAILS  ******************** */

		default:
			return state;
	}
};
